import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ChangePasswordParams,
  GetProfileResponse,
  updateProfile,
} from '../entities/profile.entity';
@Injectable()
export abstract class ProfileServices {
  /**
   * @param newEmail is the new data to update email
   *
   */
  abstract updateProfileData(
    data: updateProfile,
    memberId: string
  ): Observable<any>;

  /**
   * @param newPasswords is the new data to update password
   *
   */
  abstract updatePassword(newPasswords: ChangePasswordParams): Observable<any>;

  /**
   * @param photo is the new data to update photo
   *
   */
  abstract updatePhoto(photo: any, userId: string): Observable<any>;
}
